import { render, staticRenderFns } from "./Mozio.vue?vue&type=template&id=dab9bdd2&scoped=true&"
import script from "./Mozio.vue?vue&type=script&lang=js&"
export * from "./Mozio.vue?vue&type=script&lang=js&"
import style0 from "./Mozio.vue?vue&type=style&index=0&id=dab9bdd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab9bdd2",
  null
  
)

export default component.exports